import {
  required,
  minLength,
  email,
} from 'vuelidate/lib/validators';
import { API, ENDPOINTS } from '@/app/services/api-url';

export default {
  name: 'add-share',
  props: {
    shareItem: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    email: '',
    firstName: '',
    lastName: '',
    message: null,
  }),
  methods: {
    clearData() {
      this.email = '';
      this.firstName = '';
      this.lastName = '';
      this.$v.$reset();
    },
    handleShare() {
      this.loading = true;
      this.message = null;
      this.$v.$touch();
      if (!this.$v.$anyError) {
        const shareMap = {
          COVID: 'Covid-19 Rent Relief',
          PENSION_PAYMENT_INSTRUCTION: 'Benefit Payment Instruction',
        };

        const formattedShareType = shareMap[this.shareItem.type]
          ? shareMap[this.shareItem.type]
          : this.$options.filters.types(this.shareItem.type);

        const share = {
          accountID: this.$store.getters['account/getActiveAccount'].uuid,
          emailAddress: this.email.toLowerCase(),
          firstname: this.firstName,
          lastname: this.lastName,
          sharedObjectID: this.shareItem.uuid,
          shareMessage: `${formattedShareType} for ${this.shareItem.fundName}`,
          appName: 'TOOLKIT',
        };
        API.post(ENDPOINTS.POST_SHARE, share)
          .then((res) => {
            if (res.status === 201) {
              this.$mixpanel.track('share', {
                item_type: formattedShareType,
                shared_item_uuid: this.shareItem.uuid,
                status: this.shareItem.status,
                share_uuid: res.data.data.externalShareid,
                share_email: share.emailAddress,
                share_first_name: share.firstname,
                share_last_name: share.lastname,
                share_user_name: res.data.data.username,
              });
              this.clearData();
              this.$emit('add');
              this.message = 'Successfully Shared Item!';
            }
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            this.clearData();
            this.message = `Error Sharing Item! ${err.response && err.response.data ? err.response.data.message : ''}`;
          });
      }
    },
  },
  validations: {
    email: {
      required,
      email,
    },
    firstName: {
      required,
      minLength: minLength(2),
    },
    lastName: {
      required,
      minLength: minLength(2),
    },
  },
};
